<template>
  <v-container
    fill-height
    fluid
    grid-list-xl
  >
    <v-layout
      justify-center
      wrap
    >
      <v-flex
        md12
      >
        <div>
          <material-card
            :color="color"
            title="Affiliates"
            text="A table of affiliates(external and internal)"
          >
            <v-spacer/>

            <v-dialog
              v-model="inviteDialog"
              persistent
              max-width="768px">
              <template v-slot:activator="{ on }">
                <v-layout wrap>
                  <v-flex
                    xs12
                    sm6
                    md6>
                    <v-btn
                      :color="color"
                      dark
                      class="mb-2"
                      v-on="on">Invite New Affiliate
                    </v-btn>
                  </v-flex>
                  <v-flex
                    xs12
                    sm6
                    md6>
                    <v-text-field
                      v-model="search"
                      :loading="loading"
                      append-icon="search"
                      label="Search"
                      hide-details/>
                  </v-flex>
                </v-layout>

              </template>

              <v-card>
                <v-form
                  v-model="validInvite">
                  <v-card-text>
                    <v-container grid-list-md >
                      <v-layout wrap>
                        <v-flex
                          xs12
                          sm12
                          md12>
                          <v-text-field
                            v-model="inviteUser.email"
                            :rules="[rules.required, rules.email]"
                            label="Email" />
                        </v-flex>
                        <v-flex
                          v-if="showResend"
                          xs12
                          sm12
                          md12>
                          <v-checkbox
                            v-model="inviteUser.resend"
                            label="Resend?"/>

                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer/>
                    <v-btn
                      color="blue darken-1"
                      flat
                      @click="inviteDialog = false">Cancel</v-btn>
                    <v-btn
                      color="blue darken-1"
                      flat
                      @click="invite">Invite</v-btn>
                  </v-card-actions>
                </v-form>
              </v-card>
            </v-dialog>

            <v-dialog
              v-model="dialog"
              persistent
              max-width="768px">

              <v-card>
                <v-card-text>
                  <v-container grid-list-md >
                    <v-layout wrap>
                      <v-flex
                        xs12
                        sm6
                        md6>
                        <v-text-field
                          v-model="editedItem.firstname"
                          label="First Name" />
                      </v-flex>
                      <v-flex
                        xs12
                        sm6
                        md6>
                        <v-text-field
                          v-model="editedItem.lastname"
                          label="Last Name" />
                      </v-flex>
                      <v-flex
                        xs12
                        sm12
                        md12>
                        <v-text-field
                          v-model="editedItem.address"
                          label="Address" />
                      </v-flex>
                      <v-flex
                        xs12
                        sm6
                        md6>
                        <v-text-field
                          v-model="editedItem.user.email"
                          label="Email" />
                      </v-flex>
                      <v-flex
                        xs12
                        sm6
                        md6>
                        <v-select
                          v-model="editedItem.type"
                          :items="['external','internal']"
                          label="Type"
                          dense
                        />
                      </v-flex>
                      <v-flex
                        xs12
                        sm6
                        md6>
                        <v-text-field
                          v-model="editedItem.commission_rate"
                          type="number"
                          min="0"
                          max="100"
                          label="Rate(%)"/>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer />
                  <v-checkbox
                    v-model="editedItem.user.active"
                    class="float-right"
                    label="Active"/>
                  <v-spacer/>                  <v-btn
                    color="blue darken-1"
                    flat
                    @click="close">Cancel</v-btn>
                  <v-btn
                    color="blue darken-1"
                    flat
                    @click="save">Save</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>

            <v-data-table
              :headers="headers"
              :items="UserList"
              :disable-initial-sort="true"
              :rows-per-page-items ="rowsAmount"
              :search="search"
              class="elevation-1"
            >

              <!-- change table header background and text color(or other properties) -->
              <template
                slot="headerCell"
                slot-scope="{ header }"
              >
                <span
                  class="subheading font-weight-light text-general text--darken-3"
                  v-text="header.text"
                />
              </template>
              <template #item.full_name="{ item }">{{ item.firstname }} {{ item.lastname }}</template>
              <template v-slot:items="props">
                <tr @click="editItem(props.item)">
                  <td>
                    <v-icon
                      v-if="!props.item.has_payment"
                      small
                      color="red"
                      @click="showWarningMessage('This Affiliate has not completed the payment information')">warning</v-icon>
                    {{ props.item.firstname }}
                  </td>
                  <td>
                    {{ props.item.lastname }}
                  </td>
                  <td>
                    {{ props.item.user.email }}
                  </td>
                  <td>{{ props.item.type }}</td>
                  <td>{{ props.item.commission_rate }}</td>
                  <td>{{ new Date(props.item.created_at).toLocaleString() }}</td>
                  <td> <v-icon v-if="props.item.user.active">check</v-icon></td>
                  <td class="justify-center ">
                    <v-icon
                      small
                      class="mr-2"
                      @click="editItem(props.item)">edit</v-icon>
                    <v-icon
                      small
                      @click="deleteItem(props.item)">delete</v-icon>
                  </td>
                </tr>
              </template>
            </v-data-table>
            <v-snackbar
              v-model="snack"
              :timeout="5000"
              :color="snackColor">
              {{ snackText }}
              <v-btn
                flat
                @click="snack = false">Close</v-btn>
            </v-snackbar>
          </material-card>
        </div>
      </v-flex>

    </v-layout>
  </v-container>
</template>

<script>
  import axios from 'axios'
  import { mapState } from 'vuex'

  export default {
  data: () => ({
    // invite user
    inviteDialog: false,
    showResend: false,
    validInvite: false,
    inviteUser: {
      resend: false,
      email: ''
    },

    snack: false,
    snackColor: '',
    snackText: '',
    rules: {
      required: value => !!value || 'Required.',
      // counter: value => value.length <= 20 || 'Max 20 characters',
      email: value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return pattern.test(value) || 'Invalid e-mail.'
      }
    },
    pagination: {},
    UserList: [

    ],
    loading: true,

    checkboxAdmin: true,
    checkboxActive: true,
    rowsAmount: [10, 20, 50, { 'text': '$vuetify.dataIterator.rowsPerPageAll', 'value': -1 }],
    dialog: false,
    search: '',
    headers: [
      {
        text: 'First Name',
        align: 'left',
        value: 'firstname'
      },
      {
        text: 'Last Name',
        align: 'left',
        value: 'lastname'
      },
      {
        text: 'Email',
        align: 'left',
        value: 'user.email'
      },
      {
        text: 'Type',
        align: 'left',
        value: 'type'
      },
      {
        text: 'Rate(%)',
        align: 'left',
        width: '20px',
        value: 'commission_rate'
      },
      {
        text: 'Created At',
        align: 'left',
        value: 'created_at'
      },
      {
        text: 'Active',
        align: 'left',
        value: 'user.active'
      },
      {
        text: 'Actions',
        align: 'left',
        value: 'actions',
        sortable: false
      }

    ],
    editedIndex: -1,
    editedItem: {
      user_id: '-1',
      user: {
        email: '',
        active: true
      },
      type: '',
      commission_rate: '',
      firstname: '',
      lastname: '',
      address: ''
    },
    defaultItem: {
      user_id: '-1',
      user: {
        email: '',
        active: true
      },
      type: '',
      commission_rate: '',
      firstname: '',
      lastname: '',
      address: ''
    }
  }),

  computed: {
    ...mapState('app', ['color']),
    formTitle () {
      return this.editedIndex === -1 ? 'New Affiliate' : 'Edit Affiliate'
    }
  },

  watch: {
    dialog (val) {
      val || this.close()
    },
    'editedItem.firstname' (val) {
      this.editedItem.user.name = val + ' ' + this.editedItem.lastname
    },
    'editedItem.lastname' (val) {
      this.editedItem.user.name = this.editedItem.firstname + ' ' + val
    }
  },
  // called when page is created before dom
  created () {
    this.index()
    // this.$store.dispatch('autoRefreshToken')
    // .then(response => console.log(response))
    // .catch(error => console.log(error))
  },

  methods: {
    invite () {
      if (this.validInvite) {
        this.$store.state.spinning = true
        axios.post('/api/admin/affiliates/invite', this.inviteUser)
                .then(response => {
                  let status = response.data.status
                  this.snack = true
                  this.snackColor = 'success'
                  if (status === 'Joined') {
                    this.snackText = 'The affiliate exists already!'
                    this.showResend = false
                      this.inviteDialog = false
                  } else if (status === 'Invited') {
                    this.snackText = 'The affiliate has been invited, you can resend it!'
                    this.showResend = true
                  } else if (status === 'Sent') {
                    this.snackText = 'An invite email has been sent to the user!'
                      this.inviteDialog = false
                      this.showResend = false
                  }
                  this.$store.state.spinning = false
                })
                .catch(err => {
                  if (err.response.status == '403') {
                    this.showError('Unauthorized')
                  } else {
                    this.showError(err.response.data.errors)
                  }
                  console.log(err.response.data.errors)
                  this.$store.state.spinning = false
                })
      }
    },
    index () {
      this.loading = true
      let self = this
      axios.get('/api/admin/affiliates')
              .then(response => {
                this.UserList = response.data
                self.loading = false
              })
              .catch(err => {
                if (err.response.status == '403') {
                  this.showError('Unauthorized')
                } else {
                  this.showError(err.response.data.errors)
                }
                self.loading = false
                console.log(err.response.data.errors)
              })
    },

    // object.assign fills in the empty object with the properties of item
    editItem (item, dbox = true) {
      this.editedIndex = this.UserList.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.editedItem.user = Object.assign({}, item.user)
      this.dialog = dbox
    },

    callTableAction (item, endpoint, method) {
      let tableItem = this.editedItem
      this.$store.dispatch('updateTableItem', { endpoint, tableItem, method })
        .then((response) => this.saveInline())
        .catch(error => {
          console.log(error)
          this.cancelInline
        })
    },

    deleteItem (item) {
      const index = this.UserList.indexOf(item)
      if (confirm('Are you sure you want to delete this item?')) {
        this.$store.state.spinning = true

        axios.delete('/api/admin/affiliates/' + item.user_id)
                .then((response) => {
                  this.UserList.splice(index, 1)
                          this.deleteInline()
                          this.close()
                  this.$store.state.spinning = false
                        }
                )
                .catch(error => {
                  if (error.response.status == '403') {
                    this.showError('Unauthorized')
                  } else {
                    this.showError(error.response.data.errors)
                  }
                  console.log(error)
                  this.cancelInline
                  this.$store.state.spinning = false
                })
      }
    },

    close () {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },

    save () {
      if (this.editedItem.user_id > -1) {
        this.$store.state.spinning = true
        axios.put('/api/admin/affiliates/' + this.editedItem.user_id, this.editedItem)
          .then((response) => {
            Object.assign(this.UserList[this.editedIndex], this.editedItem)

            this.saveInline()
              this.close()
                    this.$store.state.spinning = false
                  }
          )
          .catch(error => {
            if (error.response.status == '403') {
              this.showError('Unauthorized')
            } else {
              this.showError(error.response.data.errors)
            }
            console.log(error)
            this.cancelInline
            this.$store.state.spinning = false
          })
      }
      // else {
      //   let tableItem = this.editedItem
      //   this.UserList.push(this.editedItem)
      //   let endpoint = `users/new-user`
      //   let method = 'post'
      //   this.$store.dispatch('updateTableItem', { endpoint, tableItem, method })
      //     .then((response) => console.log('new user'))
      //     .catch(error => {
      //       console.log(error)
      //       this.cancelInline
      //     })
      // }
    },
    // toasts/snackbar messages for actions
    saveInline () {
      this.snack = true
      this.snackColor = 'success'
      this.snackText = 'Affiliate saved'
    },
    deleteInline () {
      this.snack = true
      this.snackColor = 'success'
      this.snackText = 'Affiliate deleted'
    },
    showError (errorMessage) {
      this.snack = true
      this.snackColor = 'error'
      this.snackText = errorMessage || 'Something went wrong, try again later!'
    },
    cancelInline () {
      this.snack = true
      this.snackColor = 'error'
      this.snackText = 'Canceled'
    },
    reset () {
      this.snack = true
      this.snackColor = 'success'
      this.snackText = 'Data reset to default'
    },
    openInline () {
      this.snack = true
      this.snackColor = 'info'
      this.snackText = 'Dialog opened'
    },
    showWarningMessage (message) {
      this.snack = true
      this.snackColor = 'warning'
      this.snackText = message
    },
    closeInline () {
      console.log('Dialog closed')
    }
  }
}
</script>

<style>
table.v-table thead tr {
  color: red !important;
}
tbody tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, .05);
}
</style>
